import React, { Component }  from 'react';
import '../stylesheet/CustomNavbar.css';
import '../stylesheet/style.css';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { supabase } from '../config/supabase';
import { ADMIN_AUTH_EVENT, broadcastAdminAuthChange } from '../actions/authEvents';
import {
    LuHouse,
    LuList,
    LuStar,
    LuGraduationCap,
    LuBriefcase,
    LuMail,
    LuLogOut,
    LuAward,
    LuChartColumn
  } from "react-icons/lu";

// Shared across logged-in/public nav - `end: true` means "only active on an
// exact match" (otherwise Home would read as active on every route, since
// every path starts with "/").
const NAV_LINKS = [
    { to: '/', label: 'Home', Icon: LuHouse, end: true },
    { to: '/projects', label: 'Projects', Icon: LuList },
    { to: '/skills', label: 'Skills', Icon: LuStar },
    { to: '/education', label: 'Education', Icon: LuGraduationCap },
    { to: '/experience', label: 'Experience', Icon: LuBriefcase },
    { to: '/achievements', label: 'Achievements', Icon: LuAward },
];

class CustomNavbar extends Component {

    constructor(props) {
        super(props);
        this.state = { isLoggedIn: false };
    }

    componentDidMount() {
        this.syncLoginState();
        // This navbar is rendered once outside <Routes> and never remounts
        // on navigation, unlike the page components - so a same-tab login
        // on /admin needs this event (fired by Login.jsx) to be noticed.
        window.addEventListener(ADMIN_AUTH_EVENT, this.syncLoginState);
    }

    componentWillUnmount() {
        window.removeEventListener(ADMIN_AUTH_EVENT, this.syncLoginState);
    }

    syncLoginState = () => {
        this.setState({ isLoggedIn: localStorage.getItem('adminLoggedIn') });
    }

    handleSignout = async (event) => {
        event.preventDefault();
        await supabase.auth.signOut();
        localStorage.removeItem('adminLoggedIn');
        broadcastAdminAuthChange();
        window.location.href = '/';
    }

    // Which tab is "current" - exact match for `end` routes (Home), prefix
    // match for the rest so e.g. /projects stays highlighted on any
    // sub-route under it.
    isActive = (to, end) => {
        const path = this.props.pathname;
        return end ? path === to : (path === to || path.startsWith(`${to}/`));
    }

    render() {
        const { isLoggedIn } = this.state;
        const links = isLoggedIn
            // "Inbox" (contact form messages) and "Analytics" (real site
            // traffic) used to share the label "Visits" between them -
            // renamed the former so the new stats page isn't confused
            // with it.
            ? [...NAV_LINKS, { to: '/message', label: 'Inbox', Icon: LuMail }, { to: '/analytics', label: 'Analytics', Icon: LuChartColumn }]
            : [...NAV_LINKS, { to: '/contact', label: 'Contact', Icon: LuMail }];

        return (
            <Navbar collapseOnSelect>
                <Navbar.Collapse>
                    <Nav>
                        {links.map(({ to, label, Icon, end }) => {
                            const active = this.isActive(to, end);
                            return (
                                <NavItem
                                    key={to}
                                    componentClass={Link}
                                    href={to}
                                    to={to}
                                    active={active}
                                    aria-current={active ? 'page' : undefined}
                                >
                                    <Icon/><span> {label}</span>
                                </NavItem>
                            );
                        })}
                    </Nav>
                </Navbar.Collapse>
                {isLoggedIn && (
                    <button
                        type="button"
                        className="navbar-logout-box"
                        onClick={this.handleSignout}
                        aria-label="Log out of admin"
                    >
                        <LuLogOut />
                    </button>
                )}
            </Navbar>
        );
    }
};

// react-router v6 dropped withRouter, and this stays a class component for
// consistency with the rest of the site - so the route match is read via
// the hook in a tiny wrapper and handed down as a prop instead.
export default function CustomNavbarRoute(props) {
    const { pathname } = useLocation();
    return <CustomNavbar {...props} pathname={pathname} />;
}
